import React from 'react';
import { Stack } from '@/theme/index';
import { SmartInsightDetails } from './SmartInsightDetails/SmartInsightDetails';
import { VehicleSmartInsightHistoryBasedValue } from './VehicleSmartInsightHistoryBasedValue/VehicleSmartInsightHistoryBasedValue';
import { StyledDivider } from './components';

interface VehicleSmartInsightProps {
  averageMarketValue: number;
}

export function VehicleSmartInsight({
  averageMarketValue,
}: VehicleSmartInsightProps) {
  return (
    <Stack data-testid="VehicleSmartInsight">
      <StyledDivider />
      <VehicleSmartInsightHistoryBasedValue
        averageMarketValue={averageMarketValue}
      />
      <SmartInsightDetails />
    </Stack>
  );
}
